export default __webpack_public_path__ + "static/media/12-Hire-the-Pros.112d653d.jpg";